import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertDialog from 'components/HubertUI/HubertDialog';
import JobApplication from 'components/Jobs/Job/JobTab/JobApplication';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import {
  toggleJobApplicationDialog,
  toggleRefetchJobApplicationsTableData,
  toggleRefetchJobTabCards,
} from 'rtk/layout/LayoutControlSlice';
import { useRejectApplicationMutation } from 'rtk/query/apis/applications';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { toast } from 'sonner';
import type { TExtendedApplication } from 'types/application.types';

const JobApplicationDialog = () => {
  const dispatch = useAppDispatch();
  const dialog = useAppSelector((state) => state.Layout.jobApplicationDialog);
  const data = dialog.data;

  const [jobId, setJobId] = useState<string>();
  const [applicationId, setApplicationId] = useState<string>();
  const [currentRow, setCurrentRow] = useState<TExtendedApplication>();
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [rows, setRows] = useState<TExtendedApplication[]>();
  // console.log('JobApplicationDialog data', data);

  const [rejectApplicationRequest, { isLoading: isRejectApplicationRequestLoading }] = useRejectApplicationMutation();

  useEffect(() => {
    setJobId(data?.jobId);
    setApplicationId(data?.applicationId);
    setCurrentRow(data?.currentRow);
    setRows(data?.rows);
    if (data?.rows && data?.currentRow) {
      setCurrentIndex(data?.rows.findIndex((row) => row.rowId === data?.currentRow?.rowId));
    }
  }, [data]);

  useEffect(() => {
    if (rows && rows.length) {
      setCurrentIndex(rows?.findIndex((row) => row.rowId === currentRow?.rowId));
    }
  }, [currentRow]);

  const close = () => {
    dispatch(
      toggleJobApplicationDialog({
        show: false,
        data: undefined,
      }),
    );
  };

  // console.log('currentIndex', currentIndex)
  // console.log('rows', rows)

  return (
    <HubertDialog
      open={dialog.show}
      // overlay={true}
      // modal={true}
    >
      <HubertDialog.Content
        closeButton={true}
        portalContent={false}
        closeFunction={() => {
          close();
        }}
        position="center"
        className={clsx('flex flex-col justify-between gap-4')}
      >
        <JobApplication jobId={jobId} applicationId={currentRow && currentRow._id} currentRow={currentRow} />

        <div className={clsx('flex flex-row justify-between gap-4')}>
          <HubertDialog.Close>
            <HubertButton
              size={'sm'}
              variant={'secondary'}
              onClick={() => {
                close();
              }}
            >
              Close
            </HubertButton>
          </HubertDialog.Close>

          <div className="flex flex-row justify-center gap-4">
            <HubertButton
              size={'sm'}
              variant={'secondary'}
              disabled={rows && currentIndex !== undefined && currentIndex > 0 ? false : true}
              onClick={() => {
                if (currentIndex! > 0) {
                  const prev = rows![currentIndex! - 1];
                  setCurrentRow(prev);
                }
              }}
            >
              <ChevronLeft className="h-4 w-4 cursor-pointer" />
            </HubertButton>

            <HubertButton
              size={'sm'}
              variant={'secondary'}
              disabled={rows && currentIndex !== undefined && currentIndex < rows.length - 1 ? false : true}
              onClick={() => {
                if (currentIndex! < rows!.length - 1) {
                  const next = rows![currentIndex! + 1];
                  setCurrentRow(next);
                }
              }}
            >
              <ChevronRight className="h-4 w-4 cursor-pointer" />
            </HubertButton>
          </div>

          <div className={clsx('flex flex-row justify-end gap-4')}>
            {/*
          <HubertButton
            size={'sm'}
            variant={'outline'}
            icon={<ShareIcon className='w-3 h-3' />}
          >
            Share
          </HubertButton>
          */}

            <HubertDialog.Close>
              <HubertButton
                size={'sm'}
                loading={isRejectApplicationRequestLoading}
                variant={'destructive'}
                onClick={() => {
                  rejectApplicationRequest(applicationId)
                    .unwrap()
                    .then((result: any) => {
                      console.log('result', result);

                      const currentIndex = rows?.findIndex((row) => row.rowId === currentRow?.rowId);
                      if (currentIndex! < rows!.length - 1) {
                        const next = rows![currentIndex! + 1];
                        setCurrentRow(next);
                      }
                      toast.success(result.message ?? 'Application rejected.');
                      dispatch(toggleRefetchJobApplicationsTableData({ refetch: true }));
                      dispatch(toggleRefetchJobTabCards({ refetch: true }));
                      // close();
                    })
                    .catch((rejected: any) => {
                      console.log('updateClientResponsibleId rejected', rejected);
                      toast.error(`Error: ${rejected.message}`);
                    });
                }}
              >
                Reject
              </HubertButton>
            </HubertDialog.Close>
          </div>
        </div>
      </HubertDialog.Content>
    </HubertDialog>
  );
};

export default JobApplicationDialog;
